import React, { FC } from 'react';
import { ImageDataLike } from 'gatsby-plugin-image';
import { ReportsFeedFragment, Kfh_ContentMarketReportType } from '../types/graphqlTypes';
import { Card } from './Card';
import { CardCarouselWrapper } from './CardCarouselWrapper';
import { Section } from './Section';

interface ReportsFeedProps extends ReportsFeedFragment {
  width: 'narrow' | 'wide';
}

export const ReportsFeed: FC<Omit<ReportsFeedProps, '__typename'>> = ({
  title,
  backgroundColour,
  marketReports,
  width,
}) => {
  if (marketReports.length < 1) {
    return null;
  }

  return (
    <Section
      contained
      background={backgroundColour || 'grey'}
      narrow={width === 'narrow'}
      customButton={{
        label: 'View all market reports',
        url: `/about-kfh/market-reports/`,
        variant: 'solid',
        arrowRight: true,
      }}
      overflowHidden
    >
      <CardCarouselWrapper heading={title} width={width}>
        {marketReports.map(({ layout, relativeUrl }, index) => {
          const { title: reportTitle, year, season, coverImage } = layout as Kfh_ContentMarketReportType;
          return (
            <Card
              key={index}
              image={coverImage?.localFile as unknown as ImageDataLike}
              heading={reportTitle}
              meta={`${season} ${year}`}
              url={relativeUrl}
              actionLabel="Read report"
              backgroundColor={backgroundColour === 'white' || !backgroundColour ? 'grey1' : 'white'}
            />
          );
        })}
      </CardCarouselWrapper>
    </Section>
  );
};
